// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3jFTu","paramInput":"JobSimulator_paramInput__23t5G","input":"JobSimulator_input__2JMPX"};